import React, { ReactNode } from 'react';
import styled from '@emotion/styled';
import { color } from 'src/shared/styles/variables';
import { layout } from '@modernhealth/vital-foundation';
import { IconButton } from '@modernhealth/vital-components';

export interface Props {
    children: ReactNode;
    onRedirect: () => void;
    testId?: string;
}

export const DailyPausePageWrapper: React.FC<Props> = ({ children, onRedirect, testId }) => {
    return (
        <>
            <CloseButton
                title="Dismiss"
                icon="x"
                size="medium"
                variant="secondary"
                onClick={onRedirect}
            />
            <ModalWrapper data-testid={testId}>{children}</ModalWrapper>
        </>
    );
};

const CloseButton = styled(IconButton)({
    position: 'absolute',
    top: '24px',
    right: '24px',
    zIndex: 1,
});

const ModalWrapper = styled.div({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    maxWidth: layout.containerWidth,
    margin: '-80px auto 0',
    paddingLeft: layout.containerPaddingX,
    paddingRight: layout.containerPaddingX,
    paddingBottom: layout.footerHeight,
    minHeight: '100vh',
    background: color.white,
});
